import { type API, type TRequestsHandler } from '~/utils/requestsProcessor/types';

export class MiscImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /config */
  public getConfig() {
    return this.makeRequest<Record<string, string>>(`config`, { method: 'GET' });
  }

  /** GET /validation */
  public getValidation(query: { address: string; amount: string }) {
    return this.makeRequest<{
      code: number;
      data: { message: any } | API.ValidateAddressData;
    }>(`validation`, {
      method: 'GET',
      query
    });
  }

  /** POST /subscribe-email */
  public postSubscribeEmail(body: {
    contact: {
      channels: {
        type: string;
        value: string;
      }[];
    };
  }) {
    return this.makeRequest<{
      code: number;
      data:
        | { message: any }
        | {
            message: string;
            id?: number;
            isNew?: boolean;
            emailStatus?: string;
          };
    }>(`subscribe-email`, { method: 'POST', body });
  }

  /** GET /bundles/list */
  public getBundlesList() {
    return this.makeRequest<API.BundleListResponse>(`bundles/list`, {
      method: 'GET'
    });
  }

  /** GET /internal-dex/pairs */
  public getInternalDexPairs() {
    return this.makeRequest<API.InternalDexPairsListResponse>(`internal-dex/pairs`, {
      method: 'GET'
    });
  }
}
